import { ApiClient } from './client.js'
import { PRODUCTS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (productId) {
    return client.get(`${PRODUCTS}${productId}/`)
  },

  list () {
    return client.get(`${PRODUCTS}`)
  },

  listAll () {
    return client.getAll(`${PRODUCTS}`)
  }
}
